module.exports = __webpack_public_path__ + "static/media/retreat.3636c2b9.JPG";